import axios from 'axios'

const TOKEN_KEY = 'romset.token'

const client = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api',
  timeout: 15000,
})

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

client.interceptors.response.use(
  (r) => r,
  (error) => {
    // 401 UNAUTHORIZED: 토큰 폐기 후 /login으로 (auth 엔드포인트 자체는 제외)
    if (error?.response?.status === 401) {
      const url = error?.config?.url ?? ''
      if (!url.includes('/auth/')) {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem('romset.refresh')
        const next = encodeURIComponent(location.pathname + location.search)
        if (location.pathname !== '/login') location.assign(`/login?next=${next}`)
      }
    }
    return Promise.reject(error)
  },
)

export default client
